import React from 'react';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { ThemeContext } from '../../utils/context';

// Langage
import "../../i18n";
import { useTranslation } from 'react-i18next';

import { MessageCircle } from 'lucide-react';
import SEO from '../../Components/SEO';

function Contact() {
  const { theme } = useContext(ThemeContext);
  const { t } = useTranslation();

  return (
    <div className="w-full min-h-screen p-4 mt-8 mx-auto flex flex-col items-center justify-center">
      <SEO
        title={t('contact_title') || 'Contact'}
        description={t('contact_meta') || 'Contactez-nous pour vos projets web, SEO et marketing.'}
        canonical={'https://safaridew.vercel.app/Contact'}
      />
      <h4 className="text-2xl font-bold mb-4">{t("contact_desc")}</h4>
      <form
        className={`flex flex-col items-center p-4 w-full max-w-md space-y-4 ${theme === 'light' ? '' : 'dark'
          }`}
      >
        <input
          type="email"
          placeholder={t("email")}
          className="w-full p-3 border rounded-lg bg-transparent border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 placeholder:text-gray-400 dark:border-gray-400"
        />
        <input
          type="text"
          placeholder={t("contact_object")}
          className="w-full p-3 border rounded-lg bg-transparent border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 placeholder:text-gray-400 dark:border-gray-400"
        />
        <textarea
          cols="30"
          rows="5"
          placeholder={t("message")}
          className="w-full p-3 border rounded-lg bg-transparent border-gray-600 focus:border-blue-500 focus:outline-none focus:ring-0 placeholder:text-gray-400 dark:border-gray-400"
        ></textarea>
        <button
          type="submit"
          className="w-full p-3 rounded-lg bg-gray-200 dark:bg-gray-600  hover:bg-gray-300 dark:hover:bg-gray-700 transition"
        >
          {t("send")}
        </button>
      </form>

      <div className={`h-[2px] w-full max-w-md rounded-full my-4 ${theme === 'light' ? 'bg-gray-300' : 'bg-gray-700'}`}></div>

      <button
        className="w-4/5 md:w-2/5 max-w-md py-2 rounded-lg bg-transparent border border-gray-500 hover:bg-green-500/50 transition flex items-center justify-center"
      >
        <Link
          to="https://api.whatsapp.com/send/?phone=243850605759&text&type=phone_number&app_absent=0"
          target="_blank"
          className="flex items-center gap-1"
        >
          <MessageCircle className='w-10 text-green-500' />
          <span>{t("direct")}</span>
        </Link>
      </button>
    </div>
  );
}

export default Contact;
